export const getNumberDigitsAfterDecimal = (value: number | null) => {
  const valueString = value?.toString ? value.toString() : ''
  const decimalIndex = valueString.indexOf('.')
  if (decimalIndex === -1) {
    return 0
  }
  return valueString.length - decimalIndex - 1
}

export const subtractDecimalValues = (value1: number | null, value2: number | null): number => {
  const digitsAfterDecimal1 = getNumberDigitsAfterDecimal(value1)
  const digitsAfterDecimal2 = getNumberDigitsAfterDecimal(value2)
  const maxDigits = Math.max(digitsAfterDecimal1, digitsAfterDecimal2)

  const factor = 10 ** maxDigits
  const value1Adjust = value1 ?? 0
  const value2Adjust = value2 ?? 0
  return (Math.trunc(value1Adjust * factor) - Math.trunc(value2Adjust * factor)) / factor
}
